var map = {
	"./down1.png": "f182",
	"./down2.png": "b0c1",
	"./down3.png": "6731",
	"./drink3.png": "3344",
	"./drink4.png": "27ad",
	"./drink5.png": "e479",
	"./drinkbg.png": "4713",
	"./drinkicon1.png": "3e1c",
	"./drinkicon2.png": "7dda",
	"./fitness-xiaochengxucode.png": "bd57",
	"./fitness1.png": "469b",
	"./fitness2.png": "1a33",
	"./fitness3.png": "4a6e",
	"./fitness4.png": "5a6e",
	"./fitnessbg1.png": "6e3f",
	"./fitnessbg2.png": "045f",
	"./librarybg1.png": "dd7d",
	"./librarybg2.png": "7a54",
	"./librarybg3.png": "662a",
	"./librarybg4.png": "115d",
	"./logo.png": "5733",
	"./navbg.png": "632a",
	"./p1.png": "10ff",
	"./p10.png": "a365",
	"./p11.png": "43bf",
	"./p12.png": "7284",
	"./p3.png": "ba5b",
	"./p4.png": "0835",
	"./p5.png": "448d",
	"./p6.png": "5591",
	"./p7.png": "250b",
	"./p8.png": "0918",
	"./p9.png": "777b",
	"./shared1.png": "4bfe",
	"./shared10.png": "e07c",
	"./shared11.png": "6184",
	"./shared2.png": "a987",
	"./shared3.png": "f980",
	"./shared4.png": "9956",
	"./shared5.png": "bdae",
	"./shared6.png": "5b97",
	"./shared7.png": "58bf",
	"./shared8.png": "bf15",
	"./shared9.png": "c4bd",
	"./sharedbg.png": "07b8",
	"./shopIndex-xiaochengxucode.png": "8898",
	"./starbucks1.png": "c040",
	"./starbucks2.png": "7f80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cd9";